import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Estilos base
import "./React-calendar-overrides.css"; // Tus estilos personalizados
import axios from "axios";

const CalendarioReactCalendar = () => {
  const [reservas, setReservas] = useState([]);
  const [apartamentos, setApartamentos] = useState([]);
  const [filtroApartamento, setFiltroApartamento] = useState("todos");
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());

  useEffect(() => {
    const fetchReservas = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reservas`
        );
        setReservas(response.data);
      } catch (err) {
        console.error("Error al cargar las reservas:", err);
      }
    };

    const fetchApartamentos = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/apartamentos`
        );
        setApartamentos(response.data);
      } catch (err) {
        console.error("Error al cargar los apartamentos:", err);
      }
    };

    fetchReservas();
    fetchApartamentos();
  }, []);

  // Filtra las reservas de un día dado y del apartamento (si se filtra)
  const obtenerReservasDelDia = (fecha) => {
    return reservas.filter((reserva) => {
      const inicio = new Date(reserva.fecha_inicio);
      const fin = new Date(reserva.fecha_fin);
      const enRango = fecha >= inicio && fecha <= fin;
      const cumpleFiltro =
        filtroApartamento === "todos" ||
        reserva.apartamento_id === parseInt(filtroApartamento);
      return enRango && cumpleFiltro;
    });
  };

  // Cambia la fecha seleccionada
  const onChangeFecha = (nuevaFecha) => {
    setFechaSeleccionada(nuevaFecha);
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      {/* Card principal */}
      <div className="bg-white rounded-lg shadow-lg p-6">
        {/* Filtro por Apartamento */}
        <div className="mb-4">
          <label className="block text-gray-700 font-semibold mb-2">
            Filtrar por Apartamento:
          </label>
          <select
            value={filtroApartamento}
            onChange={(e) => setFiltroApartamento(e.target.value)}
            className="border p-2 rounded"
          >
            <option value="todos">Todos</option>
            {apartamentos.map((apto) => (
              <option key={apto.id} value={apto.id}>
                {apto.nombre}
              </option>
            ))}
          </select>
        </div>

        {/* Calendario principal */}
        <Calendar
          onChange={onChangeFecha}
          value={fechaSeleccionada}
          // Si quieres ocultar el salto de año (flechas dobles):
          next2Label={null}
          prev2Label={null}
          // tileContent para mostrar reservas en cada día
          tileContent={({ date, view }) => {
            if (view === "month") {
              const reservasEnDia = obtenerReservasDelDia(date);
              if (reservasEnDia.length > 0) {
                return (
                  <div className="mt-1 flex flex-col items-center">
                    {reservasEnDia.map((reserva, index) => {
                      const apto = apartamentos.find(
                        (a) => a.id === reserva.apartamento_id
                      );
                      return (
                        <div
                          key={index}
                          className="w-3/4 mb-1 text-xs text-center rounded"
                          style={{
                            backgroundColor: apto?.color || "#ddd",
                            color: "#fff",
                            padding: "2px",
                          }}
                        >
                          {reserva.cliente_nombre}
                        </div>
                      );
                    })}
                  </div>
                );
              }
            }
            return null;
          }}
        />

        {/* Reservas del día seleccionado (opcional) */}
        <div className="mt-6 bg-gray-50 p-4 rounded">
          <h2 className="text-xl font-bold mb-2 text-gray-700">
            Reservas para el {fechaSeleccionada.toLocaleDateString("es-ES")}
          </h2>
          <ul className="space-y-2">
            {obtenerReservasDelDia(fechaSeleccionada).length === 0 ? (
              <li className="text-gray-600">No hay reservas para este día.</li>
            ) : (
              obtenerReservasDelDia(fechaSeleccionada).map((reserva, i) => {
                const apto = apartamentos.find(
                  (a) => a.id === reserva.apartamento_id
                );
                return (
                  <li
                    key={i}
                    className="p-2 rounded text-white"
                    style={{ backgroundColor: apto?.color || "#ddd" }}
                  >
                    {reserva.cliente_nombre} {reserva.cliente_apellido}
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CalendarioReactCalendar;
